import React, { useEffect, useRef, useState } from 'react';
import { ChoiceOption } from '@/customTypes/chatStory';
import WaitItem from '../chatStory/story/chatItem/WaitItem';
import { css } from '@emotion/react';
import theme from '@/styles/theme';

const FONT_SIZE_MAX = 32;
const PC_FONT_SIZE_MIN = 16;
const MOBILE_FONT_SIZE_MIN = 12;

interface ChoiceTextStyle {
  left: number;
  top: number;
  width: number;
  height: number;
  align: string;
  fontsize: number;
}

interface IChoiceInputText {
  options: ChoiceOption;
  imageSize: {
    width: number;
    height: number;
  };
  rightUserInputText?: string;
}

const UserChoiceText = ({
  options,
  imageSize,
  rightUserInputText,
}: IChoiceInputText) => {
  const [choiceStyle, setChoiceStyle] = useState<ChoiceTextStyle>();
  const originRateRef = useRef<{
    left: number;
    top: number;
    right: number;
    bottom: number;
  }>({
    left: 0,
    top: 0,
    right: 0,
    bottom: 0,
  });

  useEffect(() => {
    if (options.choiceBackgroundImage) {
      originRateRef.current = {
        left:
          options.choiceBackgroundImage.leftTop[0] /
          options.choiceBackgroundImage.width,
        top:
          options.choiceBackgroundImage.leftTop[1] /
          options.choiceBackgroundImage.height,
        right:
          options.choiceBackgroundImage.rightTop[0] /
          options.choiceBackgroundImage.width,
        bottom:
          options.choiceBackgroundImage.leftBottom[1] /
          options.choiceBackgroundImage.height,
      };
    }
  }, [options]);

  useEffect(() => {
    const left = imageSize.width * originRateRef.current.left;
    const top = imageSize.height * originRateRef.current.top;
    const right = imageSize.width * originRateRef.current.right;
    const bottom = imageSize.height * originRateRef.current.bottom;
    const rect = {
      left: left,
      top: top,
      width: right - left,
      height: bottom - top,
    };

    const customContent = rightUserInputText ? rightUserInputText : undefined;
    const fontSize = customContent ? rect.width / customContent.length : -1;
    const textEffect: ChoiceTextStyle = {
      left: rect.left,
      top: rect.top,
      width: rect.width,
      height: rect.height,
      align: options.choiceBackgroundImage?.align || 'center',
      fontsize: fontSize > FONT_SIZE_MAX ? FONT_SIZE_MAX : fontSize,
    };
    setChoiceStyle(textEffect);
  }, [imageSize]);

  return (
    <>
      {choiceStyle && (
        <div css={choiceText(choiceStyle)}>
          {rightUserInputText ? (
            rightUserInputText
          ) : (
            <WaitItem isChatList={false} />
          )}
        </div>
      )}
    </>
  );
};

const choiceText = (textStyle: ChoiceTextStyle) => css`
  position: absolute;
  left: ${textStyle.left}px;
  top: ${textStyle.top}px;
  width: ${textStyle.width}px;
  height: ${textStyle.height}px;
  text-align: ${textStyle.align};
  font-size: ${textStyle.fontsize < 0
    ? 'unset'
    : textStyle.fontsize < MOBILE_FONT_SIZE_MIN
    ? MOBILE_FONT_SIZE_MIN + 'px'
    : textStyle.fontsize + 'px'};
  display: flex;
  justify-content: center;
  align-items: center;
  color: ${theme.colors.gray900};
  word-break: break-all;
  white-space: pre-line;

  @media screen and (min-width: ${theme.devices.mobile}) {
    font-size: ${textStyle.fontsize < 0
      ? 'unset'
      : textStyle.fontsize < PC_FONT_SIZE_MIN
      ? PC_FONT_SIZE_MIN + 'px'
      : textStyle.fontsize + 'px'};
  }
`;

export default UserChoiceText;
